// import { ProgressBar, Tag } from '@raspberrypifoundation/design-system-react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import 'material-symbols'
import './NextPathwayCard.scss'
// import { calculatePercentageComplete } from './calculatePercentageComplete'

const NextPathwayCard = ({ pathway }) => {
  // TODO: default showProgress to false in props
  const { i18n } = useTranslation('translations')

  // TODO: needs API change to include progress data
  // const progress = pathway.progress ?? []
  // const { progressAmount, percentComplete } =
  //   calculatePercentageComplete(progress)

  return (
    <div className="c-next-pathway-card" data-testid="next-pathway-card">
      <Link
        className="c-next-pathway-card__link"
        to={`/${i18n.language}/pathways/${pathway.slug}`}
      >
        <img
          alt=""
          className="c-next-pathway-card__image"
          src={pathway.heroImage}
        />
        <div className="c-next-pathway-card__content">
          <h2 className="c-next-pathway-card__title">{pathway.title}</h2>
          {pathway.subtitle && (
            <h3 className="c-next-pathway-card__subtitle">
              {pathway.subtitle}
            </h3>
          )}
          <p className="c-next-pathway-card__description">
            {pathway.description}
          </p>

          {/* TODO: needs API change: */}

          {/* <div className="c-next-pathway-card__tag">
            <Tag
              secondary
              icon="note_stack_add"
              text={t('general.projects-with-count', {
                count: progress.length,
              })}
              variant="default"
            />
          </div> */}
          {/* {showProgress && progress.length > 0 && (
            <div className="c-next-pathway-card__progress">
              <ProgressBar
                percent={percentComplete}
                text={t('general.progress-text', {
                  progressAmount,
                  totalSteps: progress.length,
                })}
              />
            </div>
          )} */}
        </div>
      </Link>
    </div>
  )
}

NextPathwayCard.propTypes = {
  pathway: PropTypes.shape({
    description: PropTypes.string.isRequired,
    heroImage: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    steps: PropTypes.number,
    subtitle: PropTypes.string,
    technologyTheme: PropTypes.string,
    title: PropTypes.string.isRequired,
  }).isRequired,
  showProgress: PropTypes.bool,
}

export default NextPathwayCard
